// Platform incidents (scheduler-service via the gateway). P1-6b.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface Incident {
  id: string;
  ref: string;
  severity: string; // sev1..sev4
  status: string; // investigating | identified | monitoring | resolved
  title: string;
  summary?: string | null;
  affected_services: string[];
  affected_regions: string[];
  is_public: boolean;
  root_cause?: string | null;
  started_at: string;
  resolved_at?: string | null;
  created_at: string;
  updated_at: string;
}

export interface IncidentUpdate {
  id: string;
  status?: string | null;
  body: string;
  posted_by?: string | null;
  posted_at: string;
}

const BASE = `${API_V1}/incidents/platform`;

export const listIncidents = (status?: string) =>
  axios.get<{ incidents: Incident[] }>(BASE, { params: status ? { status } : undefined })
    .then((r) => r.data.incidents || []);

export const getIncident = (id: string) =>
  axios.get<{ incident: Incident; updates: IncidentUpdate[] }>(`${BASE}/${id}`).then((r) => r.data);

export const createIncident = (input: {
  title: string; severity?: string; summary?: string;
  affected_services?: string[]; affected_regions?: string[]; is_public?: boolean;
}) => axios.post<Incident>(BASE, input).then((r) => r.data);

export const patchIncident = (id: string, patch: Partial<{
  severity: string; status: string; title: string; summary: string; is_public: boolean; root_cause: string;
}>) => axios.patch<Incident>(`${BASE}/${id}`, patch).then((r) => r.data);

export const addIncidentUpdate = (id: string, body: string, status?: string) =>
  axios.post<IncidentUpdate>(`${BASE}/${id}/updates`, { body, status }).then((r) => r.data);
